import React from 'react';
import './Parts.scss';

const Parts = ({children}) => {
  return <div className='parts'>{children}</div>;
};

export default Parts;
